export const PilotTermsLink = ({ className }) => (
  <a
    href="/pilot-terms"
    target="_blank"
    rel="noopener noreferrer"
    className={className || "ts-link"}
    data-testid="pilot-terms-link"
  >
    Pilot terms and privacy
  </a>
);
